(() => {
  const mobileQuery = window.matchMedia('(max-width: 749px)');

  function placeMediaDetails() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      const details = productInfo.querySelector('.wp-product-media-details');
      const mediaWrapper = productInfo.querySelector('.product__media-wrapper');
      const variantPicker = productInfo.querySelector('variant-selects');

      if (!details || !mediaWrapper) return;

      if (mobileQuery.matches && variantPicker) {
        variantPicker.insertAdjacentElement('afterend', details);
      } else if (!mediaWrapper.contains(details)) {
        mediaWrapper.appendChild(details);
      }
    });
  }

  function bindThumbnailRail() {
    document.querySelectorAll('.wp-product-thumbnail-slider').forEach((rail) => {
      if (rail.dataset.wpVerticalRailBound === 'true') return;

      const list = rail.querySelector('.thumbnail-list');
      if (!list) return;

      rail.dataset.wpVerticalRailBound = 'true';
      rail.querySelectorAll('.slider-button').forEach((button) => {
        button.addEventListener(
          'click',
          (event) => {
            event.preventDefault();
            event.stopImmediatePropagation();
            const direction = button.name === 'previous' ? -1 : 1;
            list.scrollBy({ top: direction * Math.max(list.clientHeight * 0.82, 120), behavior: 'smooth' });
          },
          true
        );
      });
    });
  }

  function primeGalleryMedia(gallery) {
    if (!gallery || gallery.dataset.wpMediaPrimed === 'true') return;
    gallery.dataset.wpMediaPrimed = 'true';

    const preload = () => {
      gallery.querySelectorAll('[data-media-id] img').forEach((image) => {
        image.loading = 'eager';
        image.decoding = 'async';
        const source = image.currentSrc || image.src;
        if (!source) return;
        const preloadedImage = new Image();
        preloadedImage.decoding = 'async';
        preloadedImage.src = source;
      });
    };

    if ('requestIdleCallback' in window) window.requestIdleCallback(preload, { timeout: 500 });
    else window.setTimeout(preload, 0);
  }

  function activateMedia(gallery, mediaId) {
    if (!gallery || !mediaId || typeof gallery.setActiveMedia !== 'function') return;
    gallery.setActiveMedia(mediaId, false);
  }

  function bindInstantMediaSelection() {
    document.querySelectorAll('product-info').forEach((productInfo) => {
      if (productInfo.dataset.wpInstantMediaBound === 'true') return;
      productInfo.dataset.wpInstantMediaBound = 'true';

      const gallery = productInfo.querySelector('media-gallery');
      primeGalleryMedia(gallery);

      productInfo.addEventListener(
        'change',
        (event) => {
          const input = event.target;
          if (!(input instanceof HTMLInputElement) || !input.matches('.wp-product-option--sku-images input[data-wp-media-id]')) return;
          activateMedia(gallery, input.dataset.wpMediaId);
        },
        true
      );

      gallery?.addEventListener(
        'pointerdown',
        (event) => {
          const target = event.target instanceof Element ? event.target.closest('.thumbnail[data-target]') : null;
          activateMedia(gallery, target?.dataset.target);
        },
        true
      );
    });
  }

  function initialize() {
    placeMediaDetails();
    bindThumbnailRail();
    bindInstantMediaSelection();
  }

  document.addEventListener('DOMContentLoaded', initialize);
  document.addEventListener('shopify:section:load', initialize);
  mobileQuery.addEventListener('change', placeMediaDetails);
})();
